var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAnnotationTypes = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 23.507a.5.5 0 0 0 .854.354L9.5 19.214l4.646 4.646a.5.5 0 0 0 .545.108.5.5 0 0 0 .309-.461v-19c0-.869.631-1.5 1.5-1.5a.5.5 0 0 1 0 1c-.318 0-.5.182-.5.5V7h3.5c.275.007.5-.218.5-.493v-2.5c0-2.206-1.795-4-4-4H8c-2.206 0-4 1.794-4 4z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAnnotationTypes);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/annotationTypes.svg";